import { Preferences } from '@capacitor/preferences';
import type { KeyValueStore } from './storage';

/**
 * App 内的存档后端：Capacitor Preferences（iOS UserDefaults / Android SharedPreferences）。
 * WebView 的 localStorage 在 iOS 存储紧张时可能被系统清掉，所以 App 里不用它。
 */
export class PreferencesStore implements KeyValueStore {
  constructor(private readonly prefix = 'paper-town:') {}
  async get(key: string): Promise<string | null> {
    try {
      return (await Preferences.get({ key: this.prefix + key })).value;
    } catch (err) {
      console.warn('load failed', err);
      return null;
    }
  }
  async set(key: string, value: string): Promise<void> {
    try {
      await Preferences.set({ key: this.prefix + key, value });
    } catch (err) {
      console.warn('save failed', err); // 不让游戏崩
    }
  }
  async remove(key: string): Promise<void> {
    try {
      await Preferences.remove({ key: this.prefix + key });
    } catch {
      /* ignore */
    }
  }
}
